export default __webpack_public_path__ + "static/media/R3No6.414b0854.mp3";